import "./es.array.concat-d1c9b847.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import { fpds as _, BREAKPOINTS as $ } from "@ucl/shared-component-foundations";
import { c } from "./index-8b07dec9.js";
import { Fragment as T, useState as j, useEffect as O } from "react";
import p, { css as m } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as D } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as w } from "./useWindowSize.js";
import { Divider as S } from "./divider.js";
import { hTag as G } from "./hTag.js";
import { a as H } from "./index-5d0f31c6.js";
import { jsx as r, jsxs as d } from "react/jsx-runtime";
import { Image as x } from "./image.js";
import { MediaDisclosureButton as R } from "./mediaDisclosureButton.js";
import "./export-cdcbfb2b.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-iteration-759bfbfa.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./es.array.join-c1bca812.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./es.parse-int-d7709701.js";
var A = 6, E = /* @__PURE__ */ p.li.withConfig({
  displayName: "marketingListGroup__MarketingListItem",
  componentId: "cf9vy1-0"
})(["&.MarketingList__ListItem{", ";}"], function(e) {
  var t = e.theme.components.marketingList;
  return m(t.MarketingListItem);
}), z = /* @__PURE__ */ p.ul.withConfig({
  displayName: "marketingListGroup__MarketingListGroupWrapper",
  componentId: "cf9vy1-1"
})(["&.MarketingList__Group{", ";}"], function(e) {
  var t = e.theme.components.marketingList;
  return m(t.MarketingListGroupWrapper);
}), B = /* @__PURE__ */ p.span.withConfig({
  displayName: "marketingListGroup__MarketingListIconContainer",
  componentId: "cf9vy1-2"
})(["&.MarketingList__ListIconContainer{", ";}"], function(e) {
  var t = e.theme.components.marketingList;
  return m(t.MarketingListIconContainer);
}), F = function(t) {
  var s = t.bulletType, i = s === void 0 ? "dot" : s, l = t.spacing, n = l === void 0 ? "default" : l, k = t.variant, o = t.textWeight, u = o === void 0 ? "regular" : o, g = t.iconBulletProps, a = t.listItems;
  if ((a == null ? void 0 : a.length) > A)
    throw new Error("exceeded max list items length; list items length cannot exceed 6 per marketing list group.");
  return /* @__PURE__ */ r(z, {
    className: c(["MarketingList__Group", "MarketingList__Group--" + k, "MarketingList__Group--" + i, "MarketingList__Group--" + n]),
    children: a == null ? void 0 : a.map(function(M, h) {
      return /* @__PURE__ */ d(T, {
        children: [/* @__PURE__ */ d(E, {
          className: c(["MarketingList__ListItem", "MarketingList__ListItem--" + u]),
          children: [i === "icon" && /* @__PURE__ */ r(V, Object.assign({}, g)), M]
        }), n === "divider" && h < a.length - 1 && /* @__PURE__ */ r(S, {})]
      }, h);
    })
  });
}, V = function(t) {
  var s = t.iconName, i = s === void 0 ? "caretRight" : s, l = t.color, n = l === void 0 ? _.semantic.color.icon.default : l;
  return /* @__PURE__ */ r(B, {
    role: "img",
    className: "MarketingList__ListIconContainer",
    children: i && /* @__PURE__ */ r(H, {
      icon: i || "caretRight",
      width: "20px",
      height: "20px",
      color: n,
      "data-testid": "marketing-list-bullet-icon"
    })
  });
}, X = /* @__PURE__ */ p.div.withConfig({
  displayName: "marketingListMedia__MediaWrapper",
  componentId: "ri0i59-0"
})(["&.MarketingList__Media{", ";}"], function(e) {
  var t = e.theme.components.marketingList;
  return m(t.MediaWrapper);
}), q = /* @__PURE__ */ p.div.withConfig({
  displayName: "marketingListMedia__GraphicWrapper",
  componentId: "ri0i59-1"
})(["", ";"], function(e) {
  var t = e.theme.components.marketingList;
  return m(t.GraphicWrapper);
}), K = function(t) {
  var s = t.disclosureLinks, i = t.imageProps, l = t.icon, n = t.variant, k = w(), o = k.width, u = j("1/1"), g = u[0], a = u[1];
  return O(function() {
    n === "photoSplitShort" ? o < 600 ? a("3/2") : o >= 600 && a("1/1") : n === "photoSplitLong" && (o < 600 ? a("3/2") : o >= 600 && a("3/4"));
  }, [o, n]), /* @__PURE__ */ d(X, {
    className: c(["MarketingList__Media", "MarketingList__Media--" + n]),
    "data-testid": "marketing-list-media",
    children: [["photoSplitLong", "photoSplitShort"].includes(n) && i && /* @__PURE__ */ r(x, Object.assign({
      objectFit: "fill",
      borderRadius: _.semantic.space["2x"]
    }, i, {
      ratio: g,
      "data-testid": "marketing-list-media-image"
    })), ["textStacked", "textSplit"].includes(n) && (l || i) && /* @__PURE__ */ r(q, {
      "data-testid": "marketing-list-media-icon-wrapper",
      children: l || i && /* @__PURE__ */ r(x, Object.assign({
        objectFit: "fill",
        borderRadius: _.semantic.space["2x"]
      }, i, {
        "data-testid": "marketing-list-media-image"
      }))
    }), s && /* @__PURE__ */ r(R, Object.assign({
      style: {
        bottom: ["photoSplitLong", "photoSplitShort"].includes(n) ? _.semantic.space["2x"] : "2px",
        right: ["photoSplitLong", "photoSplitShort"].includes(n) ? _.semantic.space["6x"] : "2px"
      }
    }, s))]
  });
}, U = 4, J = /* @__PURE__ */ p.div.withConfig({
  displayName: "marketingList__Wrapper",
  componentId: "sc-17ec835-0"
})(["&.MarketingList{", ";}"], function(e) {
  var t = e.theme, s = t.componentStyles, i = t.components.marketingList;
  return m(i.Wrapper, s);
}), Q = /* @__PURE__ */ p.div.withConfig({
  displayName: "marketingList__ImageContainer",
  componentId: "sc-17ec835-1"
})(["&.MarketingList__ImageContainer{", ";}"], function(e) {
  var t = e.theme.components.marketingList;
  return m(t.ImageContainer);
}), Y = /* @__PURE__ */ p.div.withConfig({
  displayName: "marketingList__ListContainer",
  componentId: "sc-17ec835-2"
})(["&.MarketingList__ListContainer{", ";}"], function(e) {
  var t = e.theme.components.marketingList;
  return m(t.ListContainer);
}), Z = /* @__PURE__ */ p.div.withConfig({
  displayName: "marketingList__HeadingWrapper",
  componentId: "sc-17ec835-3"
})(["&.MarketingList__HeadingWrapper{", ";}"], function(e) {
  var t = e.theme.components.marketingList;
  return m(t.HeadingWrapper);
}), tt = /* @__PURE__ */ p(G).withConfig({
  displayName: "marketingList__TitleWrapper",
  componentId: "sc-17ec835-4"
})(["&.MarketingList__TitleWrapper{", ";}"], function(e) {
  var t = e.theme.components.marketingList;
  return m(t.TitleWrapper);
}), it = /* @__PURE__ */ p(G).withConfig({
  displayName: "marketingList__SubTitleWrapper",
  componentId: "sc-17ec835-5"
})(["&.MarketingList__SubTitleWrapper{", ";}"], function(e) {
  var t = e.theme.components.marketingList;
  return m(t.SubTitleWrapper);
}), N = /* @__PURE__ */ p.div.withConfig({
  displayName: "marketingList__VerticalDivider",
  componentId: "sc-17ec835-6"
})(["", ";"], function(e) {
  var t = e.theme.components.marketingList;
  return m(t.VerticalDivider);
}), et = /* @__PURE__ */ p.div.withConfig({
  displayName: "marketingList__MarketingListGroupSetWrapper",
  componentId: "sc-17ec835-7"
})(["&.MarketingList__GroupSet{", ";}"], function(e) {
  var t = e.theme.components.marketingList;
  return m(t.MarketingListGroupSetWrapper);
}), Mi = function(t) {
  var s = t.variant, i = s === void 0 ? "photoSplitShort" : s, l = t.imageAlignment, n = l === void 0 ? "left" : l, k = t.titleProp, o = k === void 0 ? {
    headingLevel: "h2",
    title: "",
    size: "extraLarge"
  } : k, u = t.subTitleProp, g = u === void 0 ? {
    headingLevel: "h3",
    subTitle: ""
  } : u, a = t.mediaProps, M = t.showGroupDivider, h = M === void 0 ? !0 : M, L = t.groups, W = t.dataTestId, y = W === void 0 ? "marketing-list" : W, P = D({
    label: "MarketingList"
  }), v = w().width < $.tabletMin;
  n = v || i === "textSplit" ? "left" : n;
  var b = function() {
    return /* @__PURE__ */ d(Z, {
      className: c("MarketingList__HeadingWrapper"),
      children: [/* @__PURE__ */ r(tt, {
        className: c(["MarketingList__TitleWrapper", "MarketingList__TitleWrapper--" + (o == null ? void 0 : o.size)]),
        as: o == null ? void 0 : o.headingLevel,
        children: o == null ? void 0 : o.title
      }), (g == null ? void 0 : g.subTitle) && /* @__PURE__ */ r(it, {
        className: "MarketingList__SubTitleWrapper",
        as: g == null ? void 0 : g.headingLevel,
        children: g == null ? void 0 : g.subTitle
      })]
    });
  }, C = function() {
    return /* @__PURE__ */ d(Q, {
      className: c(["MarketingList__ImageContainer", "MarketingList__ImageContainer--" + i]),
      children: [a && ((a == null ? void 0 : a.icon) || (a == null ? void 0 : a.imageProps)) && /* @__PURE__ */ r(K, Object.assign({
        variant: i
      }, a)), !["photoSplitShort", "photoSplitLong"].includes(i) && b()]
    });
  };
  if (L.length > U)
    throw new Error("exceeded max group length; group length cannot exceed 4 per marketing list.");
  return /* @__PURE__ */ d(J, Object.assign({
    className: c(["MarketingList", "MarketingList--" + i]),
    "data-testid": y
  }, P, {
    children: [(n === "left" || ["textStacked", "textSplit"].includes(i)) && C(), ["textStacked"].includes(i) && /* @__PURE__ */ r(S, {}), ["textSplit"].includes(i) && v && /* @__PURE__ */ r(S, {}), ["textSplit"].includes(i) && !v && /* @__PURE__ */ r(N, {}), /* @__PURE__ */ d(Y, {
      className: c(["MarketingList__ListContainer", "MarketingList__ListContainer--" + i]),
      children: [["photoSplitShort", "photoSplitLong"].includes(i) && b(), /* @__PURE__ */ r(et, {
        className: c(["MarketingList__GroupSet", "MarketingList__GroupSet--" + i]),
        children: L == null ? void 0 : L.map(function(I, f) {
          return /* @__PURE__ */ d(T, {
            children: [/* @__PURE__ */ r(F, Object.assign({
              variant: i
            }, I)), (["photoSplitShort", "photoSplitLong", "textSplit"].includes(i) || v) && f < (L == null ? void 0 : L.length) - 1 && h && /* @__PURE__ */ r(S, {}), i === "textStacked" && !v && (![0, 2].includes(f) || f < (L == null ? void 0 : L.length) - 1 && h && /* @__PURE__ */ r(N, {}))]
          }, f);
        })
      })]
    }), n === "right" && !["textStacked", "textSplit"].includes(i) && C()]
  }));
};
export {
  Mi as MarketingList
};
